export const STATE_DELIMITER = '#';

export const encodeState = (...values: string[]) => {
  return btoa(values.filter(v => v).join('#'));
};

export const decodeState = (state: string) => {
  return atob(state).split(STATE_DELIMITER);
};
